module.exports = ".header-component-navbar {\r\n    /* min-height: 60px; */\r\n    color: #E3F2FD;\r\n    background-image: linear-gradient(135deg,#030B26,#212121);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.css
// module id = ./src/app/header/header.component.css
// module chunks = main